<template>
  <div>
    <h3 class="my-1">
      {{ $t('onboarding_step_2_title') }}
    </h3>
    <b-card>
      <div id="sumsub-websdk-container" />

      <div class="my-2" v-if="showButton">
        <b-link class="btn btn-outline-primary ml-1" to="/"> <FeatherIcon icon="ChevronLeftIcon"></FeatherIcon> {{ $t("back_to_dashboard") }} </b-link>
      </div>
    </b-card>

    <b-modal
      v-model="completedModal"
      style="margin-top: 30vh;"
      scrollable
      size="md"
      @hidden="$router.push('/')"
    >
      <template
        #modal-footer="{}"
        class="p-0 m-0"
      >
        <p class="d-none">
          -
        </p>
      </template>
      <div>
        <div class="d-flex alert justify-content-center text-center alert-success p-3">
          <feather-icon
            size="23"
            class="mr-1"
            icon="CheckCircleIcon"
          />
          <h4 class="text-success p-0 m-0 ">
            {{ $t('completed') }}
          </h4>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>

import snsWebSdk from '@sumsub/websdk'
import breakpoints from "swiper/src/components/core/breakpoints";

export default {
  data() {
    return {
      sumsubToken: null,
      sumsubUserId: null,
      sumsub_id: null,
      completedModal: false,
      showButton: false,
    }
  },

  created() {
    this.checkStatus()
    this.completeIdentification()
    this.calculateTime()
  },

  methods: {

    calculateTime() {
      let seconds = 8;

      const interval = setInterval(() => {
        seconds--;

        if (seconds <= 0) {
          this.showButton = true;
          clearInterval(interval); // Останавливаем таймер
        }

      }, 1000);
    },

    completeIdentification() {
      this.choiceConfirmed = true
      this.showLoader = true
      this.levelName = 'seller'
      this.$http.post('/buyer/getSumsubClientId', { role: this.levelName }).then(res => {
        if (res.data) {
          this.sumsubUserId = res.data.value.clientId
          setTimeout(() => {
            this.$http.post(`/sumsub/token?user_id=${this.$store.state.auth.user.id}&sumsub_id=${this.sumsubUserId}&level=${this.levelName}`).then(res => {
              if (res.data) {
                this.sumsubToken = res.data.token
                console.log(this.sumsubToken)
                // this.launchWebSdk(this.sumsubToken, this.$store.state.auth.user.email, this.$store.state.auth.user.tel);
                this.launchWebSdk()
              }
            })
          }, 2000)
        }
      })
    },

    launchWebSdk(accessToken, applicantEmail, applicantPhone) {
      accessToken = this.sumsubToken
      const snsWebSdkInstance = snsWebSdk.init(
        accessToken,
        () => this.getNewAccessToken(),
      )
        .withConf({
          lang: 'en',
          email: applicantEmail,
          phone: applicantPhone,
          // externalUserId: `Prod-${this.$store.state.auth.user.id}`,
          // id: this.sumsubUserId
        })
        .withOptions({ addViewportTag: false, adaptIframeHeight: true })
        .on('idCheck.onStepCompleted', payload => {
          console.log('onStepCompleted', payload)
        })
        .on('idCheck.onError', error => {
          console.log('onError', error)
        })
        .build()
      snsWebSdkInstance.launch('#sumsub-websdk-container')
      this.showLoader = false
    },

    checkStatus() {
      this.$http.post('/buyer/getSumsubClientId/status')
        .then(res => {
          if (res.data.value && res.data.value.status && res.data.value.status.review && res.data.value.status.review.reviewStatus) {
            if (res.data.value.status.review.reviewStatus == 'completed') {
              this.completedModal = true
            }
          }
        })
    },

  },

}
</script>

<style scoped>

</style>
